<!-- 未操作登出提示组件 -->
<template>
  <div class="msg-box">
    <el-row class="msg-title">
      <el-col :span="3"><i class="el-icon-warning"></i></el-col>
      <el-col :span="20">自动登出警告</el-col>
      <el-col :span="1"></el-col>
    </el-row>
    <el-row class="msg-context">
      <el-col :span="3"></el-col>
      <el-col :span="20"
        ><strong
          >系统已经三十分钟无操作，将在<span class="msg-time"
            >&nbsp;{{ countDown > 9 ? countDown : "0" + countDown }}&nbsp;</span
          >
          秒后退出登录，如不想退出系统，请任意操作鼠标键盘...</strong
        ></el-col
      >
      <el-col :span="1"></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "notify-msg",
  created() {
    this.timer = setInterval(this.handleCount, 1000);
  },
  data() {
    return {
      countDown: 60,
      timer: null,
    };
  },
  methods: {
    handleCount() {
      this.countDown--;
      if (this.countDown === 1) {
        this.$emit("logExit");
        this.timer = null;
      }
    },
  },
  beforeDestroy() {
    this.timer = null;
  },
};
</script>

<style lang="scss" scoped>
// @import url(); 引入公共css类
.msg-box {
  position: fixed;
  right: 10px;
  top: 50px;
  width: 360px;
  background: #fff;
  padding: 14px 26px 14px 13px;
  border-radius: 8px;
  border: 1px solid orange;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 100000;
  transition: all 0.3s;
  .msg-title {
    font-weight: 700;
    font-size: 16px;
    color: #303133;
    .el-icon-warning {
      color: orange;
      font-size: 26px;
    }
    .el-icon-close {
      cursor: pointer;
    }
  }
  .msg-context {
    .msg-time {
      color: red;
    }
  }
}
</style>
